import React, { useState } from "react";
import { Box, Typography, Stack, Avatar, Divider } from "@mui/material";
import { Images } from "../../assets/common";
import { isEmpty, kFormatter } from "../../constants/function";
import TopListPopup from "../TopListPopup";
export default function PlaylistStaticsCard({
  image,
  title,
  value,
  color,
  isArray,
  isTip,
  border,
  tip,
}) {
  const [open, setOpen] = useState(false);
  return (
    <Stack
      spacing={1}
      sx={{
        background: color,
        minHeight: "63px",
        border: border ? border : 0,
        borderRadius: "5px",
        padding: "16px",
      }}
      className="__responsive_playlist_statics_card"
    >
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" gap="5px">
          <img style={{ width: "22px" }} src={image} alt={title} />
          <Typography className="fs-20">{title}</Typography>
        </Stack>
      </Stack>

      <Stack direction="row" justifyContent="space-between" gap="5px">
        {isTip ? (
          <Stack
            direction="row"
            justifyContent="end"
            alignItems="center"
            sx={{ width: "100%", cursor: "pointer" }}
            onClick={() => setOpen(true)}
          >
            <img
              style={{ transform: "rotate(180deg)", marginLeft: "10px" }}
              src={Images.back}
              alt="go"
            />
          </Stack>
        ) : isArray ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ width: "100%", cursor: "pointer" }}
            onClick={() => setOpen(true)}
          >
            <Box
              className="ml_auto"
              sx={{ display: "flex", flexDirection: "row-reverse" }}
            >
              {value &&
                value.map((m, index) => (
                  <Avatar
                    sx={{ marginRight: index > 0 ? "-20px" : 0 }}
                    key={index}
                    src={m["profileImg"] ? m["profileImg"]["filePath"] : null}
                  />
                ))}
            </Box>
            {value && value.length > 0 ? (
              <img
                style={{ transform: "rotate(180deg)", marginLeft: "10px" }}
                src={Images.back}
                alt="go"
              />
            ) : null}
          </Stack>
        ) : (
          <Typography className="fs-30 ml_auto fw-b">
            {isEmpty(value) ? 0 : kFormatter(value)}
          </Typography>
        )}
      </Stack>
      {open ? (
        <TopListPopup
          isTip={isTip}
          data={value}
          isArray={isArray}
          image={isTip ? Images.music_play : Images.handHolding}
          open={open}
          handleClose={() => setOpen(false)}
        />
      ) : null}
    </Stack>
  );
}
